function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";import PortfolioScoreHolder from"@wp/src/components/common/portfolioScoreHolder";import{WpParagraph}from"@wp/src/components/common/WpTopography";export const PortfolioLabel=styled(WpParagraph)`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${props=>props.theme.colors.neutral400};

  width: 100%;
  max-height: 32px;

  &,
  &.ant-typography {
    margin: 0;
  }
`;export const GradeOverviewCard=styled.div``;export const ScoresOverviewContainer=styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;export const ScoreSectionContainer=props=>{return React.createElement(FlexLayout,_extends({flexDirection:"column",alignItems:"flex-start",itemsSpacingVertical:1,itemsSpacingHorizontal:1,flex:"1 0 0",onClick:props.onClick,cursor:props.onClick?"pointer":"inherit"},props),props.children)};export const OverviewPortfolioScoreHolder=styled(PortfolioScoreHolder)`
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
`;